import HtmlElementsStack from '../Elements/HtmlElementsStack';

/**
 * AbstractController
 *
 * @class
 */
export default class AbstractController {
  /**
   * @constructor
   */
  constructor() {
    this._htmlElementsStack = new HtmlElementsStack();
  }

  /**
   * Handles ready event
   *
   * @return void
   */
  onReady() {
    this._onEvent('onReady');
  }

  // Private

  /**
   * Handles event by name
   *
   * @return void
   */
  _onEvent(fn, e = {}) {
    this._htmlElementsStack.forEachCallFunction(fn, e);
  }

  /**
   * Registers elements and adds them to the stack
   *
   * @param { Object } elements
   * @return
   */
  _registerElements(...elements) {
    this._htmlElementsStack.attach(...elements);
  }
}
